<div class="nav-container {{ navClass ? navClass : '' }}" [class.nav--open]="isOpen$ | async">
  @if (showBackdrop) {
    <div class="nav__backdrop"></div>
  }
  <nav class="nav nav--{{ name }}" [attr.aria-label]="accessibleLabel">
    <air-link-list [linkLists]="navigationItems" [userEventSource]="userEventSource"></air-link-list>
  </nav>
</div>
